import React from "react";
import { API_URL } from "./config";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) { 
    this.setState({ errorInfo });
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  //console.log("valoare")
    // Trimite eroarea la server
    fetch(`${API_URL}/api/send-error`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        error: error.toString(),
        stack: error.stack,
        componentStack: errorInfo.componentStack, // Make sure this matches backend
      }),
    })
    .then(response => {
      if (!response.ok) {
        console.error("Server responded with error:", response.status);
      }
      return response.text();
    })
    .then(text => 
      console.log("Server response:", text)
    )
    .catch((e) => console.error("Failed to send error:", e));
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "20px", color: "red" }}>
          <h1>Ceva nu a funcționat corect.</h1>
          <details style={{ whiteSpace: "pre-wrap" }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo?.componentStack}
          </details>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;